$(document).ready(function () {
  $(".column-tab a").on("click", function (e) {
    e.preventDefault();

    // Remove 'active' class from all tabs and contents
    $(".column-tab").removeClass("active");
    $(".tab-content").removeClass("active");

    // Add 'active' class to the clicked tab
    $(this).parent().addClass("active");

    // Add 'active' class to the corresponding content
    var target = $(this).attr("href");
    $(target).addClass("active");
  });
});

$(document).ready(function () {
  $('a[href^="#judgeme_product_reviews"]').on("click", function (event) {
    event.preventDefault();
    $("html, body").animate({
        scrollTop: $($.attr(this, "href")).offset().top - 100,
      },
      500
    );
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const element = document.querySelector('.have_link_url.banner');
  if (element) {
    element.addEventListener('click', function() {
      const url = this.getAttribute('have_link_url');
      if (url) {
        window.location.href = url;
      }
    });
  }
});

// Code to exit the product media lightbox start
$(document).on('click', '.pswp__item', function (e) {
  if (!$(e.target).is('.pswp__img')) {
    $('.pswp__button--close').trigger('click');
  }
});
// Code to exit the product media lightbox end 

$(document).on('click', '.pswp__video-container video', function () {
  this.muted = false;
  this.defaultMuted = false;
  this.removeAttribute('muted');

  if (this.volume === 0) {
    this.volume = 1;
  }
});

function syncActiveLightboxVideo(retries = 0) {
  const activeItem = document.querySelector('.pswp__item[aria-hidden="false"]');
  if (!activeItem) {
    if (retries > 0) {
      setTimeout(function() {
        syncActiveLightboxVideo(retries - 1);
      }, 220);
    }
    return;
  }

  const videoElement = activeItem.querySelector('video');
  const playButton = activeItem.querySelector('.play-button');

  if (videoElement) {
    videoElement.muted = false;
    videoElement.defaultMuted = false;
    videoElement.removeAttribute('muted');

    if (videoElement.volume === 0) {
      videoElement.volume = 1;
    }

    if (videoElement.paused) {
      videoElement.play().catch(err => console.log('Autoplay blocked:', err));
      console.log('Video playing (unmuted) on active slide:', videoElement);
    }
    return;
  }

  if (playButton) {
    playButton.click();
    console.log('Play button clicked on active slide');
  }

  if (retries > 0) {
    setTimeout(function() {
      syncActiveLightboxVideo(retries - 1);
    }, 220);
  }
}

function manageVideoPlayback() {
  document.querySelectorAll('.pswp__item').forEach(item => {
    const isActive = item.getAttribute('aria-hidden') === 'false';
    const videoElement = item.querySelector('video');

    if (isActive) {
      syncActiveLightboxVideo(4);
    } else if (videoElement) {
      videoElement.muted = true;
      if (!videoElement.paused) {
        videoElement.pause();
        console.log('Video paused (muted) on inactive slide:', videoElement);
      }
    }
  });
}

// Better handling of video play on clicking .product__media
$(document).on('click', '.product__media-list .product__media', function() {
  setTimeout(() => {
    syncActiveLightboxVideo(5);
  }, 500);
});

document.addEventListener('lightbox:open', function() {
  setTimeout(function() {
    syncActiveLightboxVideo(10);
  }, 250);
});

// Arrow button click handling
$(document).on('click', '.pswp__button--arrow', function() {
  setTimeout(manageVideoPlayback, 200);
});

// Handle click on non-active slide to manage playback
$(document).on('click', '.pswp__item[aria-hidden="true"]', function() {
  manageVideoPlayback();
});


// custom js code 

  $(document).ready(function() {
    $('body').on('click', '.custom-product-atc-btn', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var $btn = $(this);

      if ($btn.attr('aria-busy') === 'true') return;

      var $form = $btn.closest('.product-form');
      var variantId = $form.find('input[name="id"]').val();
      var quantity = parseInt($form.find('input[name="quantity"]').val()) || 1;

      if (!variantId) {
        return;
      }

      $btn.attr('aria-busy', 'true').prop('disabled', true);

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }],
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to add to cart');
        return response.json();
      })
      .then(async data => {
        const cart = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
        cart.sections = data.sections;

        var $cartCount = $('cart-count');
        $cartCount.text(cart.item_count).removeAttr('hidden');

        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'custom-product-atc', cart });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            trigger: $btn[0],
            quantity: quantity
          }
        }));
        if (!theme.flyToCart()) document.querySelector('cart-drawer')?.show($btn[0]);
      })
      .catch(err => {
        alert(err.message || 'Error adding to cart');
      })
      .finally(() => {
        $btn.removeAttr('aria-busy').prop('disabled', false);
      });

    });
  });

// Cart delivery estimate display
(function () {
  function getZonedParts(timeZone) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone || undefined,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    const parts = formatter.formatToParts(new Date()).reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});

    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour === '24' ? '0' : parts.hour),
      minute: Number(parts.minute)
    };
  }

  function parseCutoff(cutoffTime) {
    const match = String(cutoffTime || '').match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return { hour: 14, minute: 0 };

    return {
      hour: Math.min(Math.max(Number(match[1]), 0), 23),
      minute: Math.min(Math.max(Number(match[2]), 0), 59)
    };
  }

  function isWeekend(date) {
    const day = date.getUTCDay();
    return day === 0 || day === 6;
  }

  function addDays(date, days, skipWeekends) {
    const next = new Date(date.getTime());
    let remaining = Math.max(Number(days) || 0, 0);

    while (remaining > 0) {
      next.setUTCDate(next.getUTCDate() + 1);
      if (!skipWeekends || !isWeekend(next)) {
        remaining -= 1;
      }
    }

    return next;
  }

  function getProcessingStartDate(parts, cutoff, skipWeekends) {
    const today = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
    const cutoffPassed = parts.hour > cutoff.hour || (parts.hour === cutoff.hour && parts.minute >= cutoff.minute);
    let startDate = cutoffPassed ? addDays(today, 1, skipWeekends) : today;

    if (skipWeekends) {
      while (isWeekend(startDate)) {
        startDate = addDays(startDate, 1, false);
      }
    }

    return startDate;
  }

  function getCutoffRemainingMinutes(parts, cutoff) {
    const nowMinutes = (parts.hour * 60) + parts.minute;
    const cutoffMinutes = (cutoff.hour * 60) + cutoff.minute;

    return cutoffMinutes - nowMinutes;
  }

  function normalizeLocale(locale) {
    return String(locale || '').replace('_', '-') || undefined;
  }

  function formatEstimateDate(date, locale) {
    return new Intl.DateTimeFormat(normalizeLocale(locale), {
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC'
    }).format(date);
  }

  function formatEstimateRange(startDate, endDate, locale) {
    const formatter = new Intl.DateTimeFormat(normalizeLocale(locale), {
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC'
    });

    if (typeof formatter.formatRange === 'function') {
      return formatter.formatRange(startDate, endDate);
    }

    return `${formatEstimateDate(startDate, locale)} - ${formatEstimateDate(endDate, locale)}`;
  }

  function formatCutoffTime(cutoff, locale) {
    const date = new Date(Date.UTC(2000, 0, 1, cutoff.hour, cutoff.minute));

    return new Intl.DateTimeFormat(normalizeLocale(locale), {
      hour: 'numeric',
      minute: '2-digit',
      timeZone: 'UTC'
    }).format(date);
  }

  function formatCountdown(minutes) {
    const safeMinutes = Math.max(Number(minutes) || 0, 0);
    const hours = Math.floor(safeMinutes / 60);
    const remainingMinutes = safeMinutes % 60;

    if (hours > 0 && remainingMinutes > 0) {
      return `${hours}h ${remainingMinutes}m`;
    }

    if (hours > 0) {
      return `${hours}h`;
    }

    return `${remainingMinutes}m`;
  }

  function updateDeliveryEstimate(element) {
    const output = element.querySelector('[data-cart-delivery-text]');
    if (!output) return;

    try {
      const minDays = Number(element.dataset.minDays) || 0;
      const maxDays = Math.max(Number(element.dataset.maxDays) || minDays, minDays);
      const skipWeekends = element.dataset.skipWeekends === 'true';
      const cutoff = parseCutoff(element.dataset.cutoffTime);
      const parts = getZonedParts(element.dataset.timezone);
      const startDate = getProcessingStartDate(parts, cutoff, skipWeekends);
      const minDate = addDays(startDate, minDays, skipWeekends);
      const maxDate = addDays(startDate, maxDays, skipWeekends);
      const locale = element.dataset.locale;
      const remainingMinutes = getCutoffRemainingMinutes(parts, cutoff);
      const useCutoff = element.dataset.useCutoff === 'true';
      const showCountdown = element.dataset.showCountdown === 'true';
      const countdownThreshold = Math.max(Number(element.dataset.countdownThreshold) || 0, 0);
      const cutoffPassed = remainingMinutes <= 0;
      const shouldShowCountdown = useCutoff && showCountdown && !cutoffPassed && (countdownThreshold === 0 || remainingMinutes <= countdownThreshold * 60);
      let template = element.dataset.template || 'Receive by [date_range]';

      if (useCutoff) {
        template = shouldShowCountdown
          ? element.dataset.countdownTemplate || element.dataset.beforeCutoffTemplate || template
          : cutoffPassed
            ? element.dataset.afterCutoffTemplate || template
            : element.dataset.beforeCutoffTemplate || template;
      }
      const startText = formatEstimateDate(minDate, locale);
      const endText = formatEstimateDate(maxDate, locale);
      const rangeText = formatEstimateRange(minDate, maxDate, locale);
      const countdownText = formatCountdown(remainingMinutes);
      const cutoffText = formatCutoffTime(cutoff, locale);

      output.textContent = template
        .replace(/\[date_range\]/g, rangeText)
        .replace(/\[start_date\]/g, startText)
        .replace(/\[end_date\]/g, endText)
        .replace(/\[countdown\]/g, countdownText)
        .replace(/\[cutoff_time\]/g, cutoffText)
        .replace(/\{\{\s*date_range\s*\}\}/g, rangeText)
        .replace(/\{\{\s*start_date\s*\}\}/g, startText)
        .replace(/\{\{\s*end_date\s*\}\}/g, endText)
        .replace(/\{\{\s*countdown\s*\}\}/g, countdownText)
        .replace(/\{\{\s*cutoff_time\s*\}\}/g, cutoffText);
      element.hidden = false;
    }
    catch (error) {
      element.hidden = true;
    }
  }

  function initCartDeliveryEstimates() {
    document.querySelectorAll('[data-cart-delivery-estimate]').forEach(updateDeliveryEstimate);
  }

  let deliveryEstimatePending = false;
  function scheduleCartDeliveryEstimates() {
    if (deliveryEstimatePending) return;
    deliveryEstimatePending = true;

    window.requestAnimationFrame(function () {
      deliveryEstimatePending = false;
      initCartDeliveryEstimates();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleCartDeliveryEstimates);
  document.addEventListener('cart:updated', scheduleCartDeliveryEstimates);
  document.addEventListener('ajaxProduct:added', scheduleCartDeliveryEstimates);
  document.addEventListener('shopify:section:load', scheduleCartDeliveryEstimates);
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(scheduleCartDeliveryEstimates, 150);
  });
  window.setInterval(scheduleCartDeliveryEstimates, 60000);

  const observer = new MutationObserver(scheduleCartDeliveryEstimates);
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// HoverButton's loading state runs a sequential ~300ms Motion fade before the
// bouncing-dots loader is visible, which lags behind the checkout form POST and
// reads as an unresponsive click. Show the same .btn-loader dots instantly via
// CSS so the indicator paints before navigation begins.
(function () {
  function showCheckoutLoading(event) {
    const btn = event.target.closest('button[name="checkout"]');
    if (!btn || btn.disabled || btn.classList.contains('instant-loading')) return;

    // HoverButton appends .btn-loader via Motion.inView -> init(). If the user
    // clicks before that fires, inject the same markup so the dots render.
    if (!btn.querySelector('.btn-loader')) {
      btn.insertAdjacentHTML('beforeend', '<span class="btn-loader"><span></span><span></span><span></span></span>');
    }
    btn.classList.add('instant-loading');
  }

  document.addEventListener('pointerdown', showCheckoutLoading, true);
  document.addEventListener('click', showCheckoutLoading, true);

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('button[name="checkout"].instant-loading').forEach(function (btn) {
      btn.classList.remove('instant-loading');
    });
  });
})();

// Optimistic cart badge: the count moves the instant a paid quantity changes or a row
// is removed; the server render corrects it right behind. Money (prices, subtotal) is
// deliberately NOT painted ahead — discounts and multi-currency make client math lie,
// and a briefly-wrong price is worse than a half-second wait. Gift rows are owned by
// nb-free-gift.js and skipped here.
(function () {
  function bumpBadge(delta) {
    if (!delta) return;
    document.querySelectorAll('cart-count').forEach(function (el) {
      var n = parseInt(el.textContent, 10);
      if (isNaN(n)) return;
      var v = Math.max(0, n + delta);
      el.textContent = v;
      if (v > 0) el.removeAttribute('hidden');
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'updates[]' || !input.closest) return;
    if (input.closest('.disable-free-item')) return;
    var next = parseInt(input.value, 10);
    var prev = parseInt(input.dataset.nbPrevQty || input.defaultValue, 10);
    if (isNaN(next) || isNaN(prev) || next === prev) return;
    // The theme rejects out-of-range values by reverting the field to defaultValue
    // WITHOUT any server call — so never bump for a value that will be rejected
    // (nothing would correct the badge), and never overwrite defaultValue (the
    // theme's revert depends on it). Delta baseline lives in a dataset key instead;
    // server renders recreate the input, resetting the baseline to server truth.
    var max = parseInt(input.max, 10);
    var min = parseInt(input.getAttribute('data-min') || input.min, 10);
    if (!isNaN(max) && next > max) return;
    if (!isNaN(min) && next < min) return;
    input.dataset.nbPrevQty = String(next);
    bumpBadge(next - prev);
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest && e.target.closest('a[is="cart-remove-button"]');
    if (!link) return;
    var row = link.closest('.cart-row');
    if (!row || row.classList.contains('disable-free-item')) return;
    bumpBadge(-(parseInt(row.getAttribute('data-quantity'), 10) || 0));
  }, true);
})();
